import React, {useContext, useEffect, useState} from "react";
import {Grid, TextField, Typography, AlertTypes, MainLoader} from "@leap4/frontend";
import {IOrganizationAdvertiserLogin} from "../../organizations/interfaces/IOrganizationAdvertiserLogin";
import {UsersContext} from "./UserContext";
import {UserOrganizationContainer} from "./UserOrganizations/UserOrganization.container";
import {useDispatch} from "react-redux";
import {getAllOrganizations} from "../../../actions/users";
import {setAlert} from "../../../actions/alert";


const DetailsForm = () => {
    const {user, setUser} = useContext(UsersContext);
        const dispatch = useDispatch();
    const [pickedOrganizations, setPickedOrganizations] = useState<IOrganizationAdvertiserLogin[]>([])
    const [allOrganizations, setAllOrganizations] = useState<IOrganizationAdvertiserLogin[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        let loadedOrganizations;
        (async () => {
            if (user._id === '') return;
            try {
                setIsLoading(true);
                loadedOrganizations = (await getAllOrganizations(dispatch) as IOrganizationAdvertiserLogin[])
                setPickedOrganizations(loadedOrganizations.filter(el =>
                    user.metadataMulti.indexOf( el._id ) > -1
                ))
                setAllOrganizations(loadedOrganizations)
            } catch (err) {
                setAlert("Couldn't load organizations", AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Grid margin={"10px"}>
            <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                USER INFO
            </Typography>
            </Grid>
            <Grid container gap={"5px"}>
                <Grid item width='40%'>
                    {(user?.name) && <Grid item lg={12} width={"100%"}>
                        <TextField fullWidth label={"Name"} disabled value={(user?.name)}/>
                    </Grid>}
                </Grid>
                <Grid item width='40%'>
                    {(user?.email) && <Grid item lg={12} width={"100%"}>
                        <TextField fullWidth label={"Email"} disabled value={(user?.email)}/>
                    </Grid>}
                </Grid>
            </Grid>
            {isLoading || user._id === '' ? (
                    <MainLoader/>
            ) : (
                <Grid>
                <UserOrganizationContainer
                    user={user}
                    setUser={setUser}
                    allOrganizations={allOrganizations}
                    pickedOrganizations={pickedOrganizations}
                />
                </Grid>
            )}
        <Grid></Grid>
        </>
    )
}
export {DetailsForm}


